import { render, staticRenderFns } from "./Hunk.vue?vue&type=template&id=6081fa25"
import script from "./Hunk.vue?vue&type=script&lang=js"
export * from "./Hunk.vue?vue&type=script&lang=js"
import style0 from "./Hunk.vue?vue&type=style&index=0&id=6081fa25&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports